import OnboardingSlide from './OnboardingSlide';
import E2EDemoAnimation from './E2EDemoAnimation';

export default function SlideProfile() {
  return (
    <OnboardingSlide
      illustration={<E2EDemoAnimation />}
      title="See It In Action"
    >
      <p>
        Watch the full workflow with <strong>Nour Al-Deen</strong> (Room 21, Pediatrics) — from
        favoriting a patient to shift handover.
      </p>
      <p className="text-xs text-gray-500">
        The demo loops automatically. Profile settings (language, feedback, logout) are available
        from your photo in the top corner anytime.
      </p>
    </OnboardingSlide>
  );
}
